export default {
  bankTransfer: 'Banküberweisung',
  firstTitle: 'Bitte wählen Sie die Überweisungswährung',
  secondTitle: 'Nach der Überweisung',
  bankTips:
    'Besorgen Sie sich die Informationen des Begünstigten und gehen Sie zur entsprechenden Bankschalter, um den Zahlungsauftrag auszufüllen. Bitte überprüfen Sie Ihre Schreibweise sorgfältig.',
  receiverTitle: 'Informationen des Begünstigten',
  bankAttrEnum: {
    0: 'Kontonummer',
    1: 'Bankleitzahl',
    2: 'Kontoinhaber',
    3: 'Bankname',
    4: 'Bankadresse',
    5: 'Postleitzahl',
    6: 'Land/Region',
    7: 'Kontotyp',
    8: 'Bemerkung',
  },
  transferTips:
    'Sie können uns auf eine der folgenden Arten informieren, und wir werden es so schnell wie möglich überprüfen!',
  transferName: 'Name des Absenders',
  transferBank: 'Bank des Absenders',
  transferNo: 'Referenznummer',
  submit: 'Jetzt einreichen',
  successSubmit: 'Erfolgreich eingereicht',
  successSubmitTips:
    '* Sollte es während der Überprüfung Probleme geben, werden wir Sie über die bei acbuy registrierte E-Mail-Adresse kontaktieren.',
  tradeDetail: 'Transaktionsdetails',
  backOrder: 'Zurück zur Bestellung',
  holder: {
    inputNo: 'Bitte geben Sie die Referenznummer an, falls vorhanden.',
  },
  transferExplain: 'Anleitung zur Banküberweisung:',
  transferExplainEnum: {
    0: 'acbuy erhebt keine Bearbeitungsgebühren für diesen Zahlungskanal. Ob die überweisende Bank Gebühren erhebt, hängt von den jeweiligen Richtlinien der entsprechenden Bank ab.',
    1: 'Diese Zahlungsmethode unterstützt mehrere Währungen. Kunden können das entsprechende Bankkonto für die Überweisung entsprechend ihrer Region und ihren Bedürfnissen auswählen.',
    2: 'Normalerweise dauert es 1-3 Werktage, bis das Geld eintrifft; unter besonderen Umständen dauert es 1-5 Werktage.',
    3: 'acbuy rechnet den Betrag nach Erhalt der Überweisung zum acbuy-Wechselkurs in RMB um und schreibt ihn Ihrem Konto gut.',
    4: 'Der endgültige RMB-Betrag auf dem acbuy-Konto = Der Betrag Ihrer Überweisung * acbuy-Plattform-Wechselkurs.',
  },
}
